export const en = {
    'add-success': 'Product added successfully',
    error: 'An error occurred, please try again'
};
